module.exports = __webpack_public_path__ + "img/kuyucuk-drop@2x.4e08af43.png";